export default __webpack_public_path__ + "static/azul-2fb849e2a82190cb27072005c31e8464.png";